import { styled } from '@mui/material'
import MuiCardActions from '@mui/material/CardActions'
import { css } from '@emotion/react'
import { CardActionsProps } from './CardActions.types'

type PropKeys = keyof CardActionsProps
const excludeProps: PropKeys[] = ['divider']

export const CardActions = styled(MuiCardActions, {
  shouldForwardProp: (prop) => !excludeProps.includes(prop as PropKeys),
})<CardActionsProps>`
  position: relative;
  padding: ${({ theme, spacing }) => theme.spacing(spacing ?? 0)};
  ${({ theme, spacing, divider }) =>
    divider &&
    css`
      ::before {
        content: '';
        width: calc(100% - (${theme.spacing(spacing ?? 0)} * 2));
        display: block;
        position: absolute;
        top: 0;
        border-top: thin solid rgba(0, 0, 0, 12%);
      }
    `}
`
